import React from 'react'
import { useTranslation } from 'react-i18next'
import OptionModal from '../../../../shared/components/OptionModal'

// Confirms archiving the current selection: ads and/or folders. A single ad or
// single folder gets specific wording; any larger / mixed selection uses a
// generic "items" message. Everything is worded as "Archive". onConfirm receives
// both id lists.
const DeleteAdsModal = ({ visible, ids = [], folderIds = [], onConfirm, onCancel }) => {
  const { t } = useTranslation()
  const adCount = ids.length
  const folderCount = folderIds.length
  const total = adCount + folderCount

  let title
  let body
  if (total > 1) {
    title = t('Archive {{count}} items', { count: total })
    body = t('Are you sure you want to archive the {{count}} selected items? This action cannot be undone.', {
      count: total,
    })
  } else if (folderCount === 1) {
    title = t('Archive folder')
    body = t('Are you sure you want to archive this folder?')
  } else {
    title = t('Archive ad')
    body = t('Are you sure you want to archive this ad? This action cannot be undone.')
  }

  return (
    <OptionModal
      visible={visible}
      title={title}
      body={body}
      okText={t('Archive')}
      cancelText={t('Cancel')}
      onOk={() => onConfirm(ids, folderIds)}
      onCancel={onCancel}
      okButtonProps={{ type: 'danger' }}
    />
  )
}

export default DeleteAdsModal
